var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtkritie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Otkritie",
    clipPath: "url(#clip0_342:15924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99994 0C7.99994 0 6.09994 0.6 4.44994 1.7C2.79994 2.8 1.49994 4.35 0.749938 6.2C-6.15716e-05 8 -0.200062 10 0.199938 11.95C0.599938 13.9 1.54994 15.65 2.94994 17.05C4.34994 18.45 6.14994 19.4 8.04994 19.8C9.94994 20.2 11.9999 20 13.8499 19.25C15.6999 18.5 17.2499 17.2 18.3499 15.55C19.3999 13.9 19.9999 12 19.9999 10C19.9999 7.35 18.9499 4.8 17.0499 2.95C15.1999 1.05 12.6499 0 9.99994 0ZM8.54994 14.25L7.79994 16.4C6.44994 15.95 5.29994 15.05 4.44994 13.9C3.59994 12.75 3.19994 11.35 3.19994 9.9C3.19994 8.45 3.64994 7.05 4.49994 5.9C5.34994 4.75 6.49994 3.85 7.84994 3.4L8.59994 5.55C7.69994 5.85 6.94994 6.45 6.39994 7.2C5.84994 7.95 5.54994 8.9 5.59994 9.85C5.54994 10.8 5.79994 11.75 6.34994 12.55C6.84994 13.35 7.64994 13.95 8.54994 14.25ZM11.9999 16.5L11.2999 14.3C12.1999 14 12.9999 13.45 13.5499 12.65C14.0999 11.9 14.3999 10.95 14.3999 10C14.3999 9.05 14.0999 8.1 13.5499 7.35C12.9999 6.55 12.1999 6 11.2999 5.7L12.0499 3.5C13.3999 3.95 14.5999 4.85 15.4499 6C16.2999 7.2 16.7499 8.6 16.7499 10.05C16.7499 11.5 16.2499 12.9 15.3999 14.05C14.5999 15.2 13.3999 16.05 11.9999 16.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_342:15924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtkritie);
export default __webpack_public_path__ + "static/media/otkritie.66c34cf2de43edec46f5f91e5a2de09a.svg";
export { ForwardRef as ReactComponent };